// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import "@/polyfills";
// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
// Cargando paquete de idioma de Vee-Validate
import es from "vee-validate/dist/locale/es";

// Validation plugin used to validate forms
import VeeValidate, { Validator } from "vee-validate";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "@/components/SidebarPlugin";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/es";
import locale from "element-ui/lib/locale";
locale.use(lang);

// asset imports
import "@/assets/sass/argon.scss";
import "@/assets/css/nucleo/css/nucleo.css";

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(VeeValidate, {
      fieldsBagName: "veeFields",
      classes: true,
      validity: true,
      classNames: {
        valid: "is-valid",
        invalid: "is-invalid"
      }
    });
    Validator.localize("es", es);
    Validator.extend("dniecuador", {
      getMessage: field => "Identificación ingresada no es válida",
      validate: data => {   

        // for (let i = 0; i < data.length; i++) {
        //   if (parseInt(data[i]) <= 9 && parseInt(data[i]) >= 0) {
        //   } else {
        //     return false;
        //   }
        // }
        // return true;

        var resultVal1 = true;

        if(
          data == '1191795354001' || 
          data == '1191795354'){
          return true;
        }
        if (data.length > 13) {
          return false
        }

        
          var numero = data
        /* alert(numero); */
    
          var suma = 0;      
          var residuo = 0;      
          var pri = false;      
          var pub = false;            
          var nat = false;      
          var numeroProvincias = 22;                  
          var modulo = 11;
                      
          /* Verifico que el campo no contenga letras */                  
          var ok=1;
          for (var i=0; i<numero.length && ok==1 ; i++){
             var n = parseInt(numero.charAt(i));
             if (isNaN(n)) ok=0;
          }
          if (ok==0){
             console.log("No puede ingresar caracteres en el número");         
             resultVal1 = false;
          }
                      
          if (numero.length < 10 ){              
             console.log('El número ingresado no es válido');                  
             resultVal1 = false;
          }
         
          /* Los primeros dos digitos corresponden al codigo de la provincia */
          var provincia = numero.substr(0,2);      
          if (provincia < 1 || provincia > numeroProvincias){           
             console.log('El código de la provincia (dos primeros dígitos) es inválido');
              resultVal1 = false;       
          }
    
          /* Aqui almacenamos los digitos de la cedula en variables. */
          var d1  = numero.substr(0,1);         
          var d2  = numero.substr(1,1);         
          var d3  = numero.substr(2,1);         
          var d4  = numero.substr(3,1);         
          var d5  = numero.substr(4,1);         
          var d6  = numero.substr(5,1);         
          var d7  = numero.substr(6,1);         
          var d8  = numero.substr(7,1);         
          var d9  = numero.substr(8,1);         
          var d10 = numero.substr(9,1);     
          
          console.log(d3);
             
          /* El tercer digito es: */                           
          /* 9 para sociedades privadas y extranjeros   */         
          /* 6 para sociedades publicas */         
          /* menor que 6 (0,1,2,3,4,5) para personas naturales */ 
    
          if (d3==7 || d3==8){           
             console.log('El tercer dígito ingresado es inválido');                     
             resultVal1 = false;
          }         
             
          /* Solo para personas naturales (modulo 10) */         
          if (d3 < 6){           
             nat = true;            
             var p1 = d1 * 2;  if (p1 >= 10) p1 -= 9;
             var p2 = d2 * 1;  if (p2 >= 10) p2 -= 9;
             var p3 = d3 * 2;  if (p3 >= 10) p3 -= 9;
             var p4 = d4 * 1;  if (p4 >= 10) p4 -= 9;
             var p5 = d5 * 2;  if (p5 >= 10) p5 -= 9;
             var p6 = d6 * 1;  if (p6 >= 10) p6 -= 9; 
             var p7 = d7 * 2;  if (p7 >= 10) p7 -= 9;
             var p8 = d8 * 1;  if (p8 >= 10) p8 -= 9;
             var p9 = d9 * 2;  if (p9 >= 10) p9 -= 9;             
             modulo = 10;
          }         
    
          /* Solo para sociedades publicas (modulo 11) */                  
          /* Aqui el digito verficador esta en la posicion 9, en las otras 2 en la pos. 10 */
          else if(d3 == 6){           
             pub = true;             
             p1 = d1 * 3;
             p2 = d2 * 2;
             p3 = d3 * 7;
             p4 = d4 * 6;
             p5 = d5 * 5;
             p6 = d6 * 4;
             p7 = d7 * 3;
             p8 = d8 * 2;            
             p9 = 0;            
          }         
             
          /* Solo para entidades privadas (modulo 11) */         
          else if(d3 == 9) {           
             pri = true;                                   
             p1 = d1 * 4;
             p2 = d2 * 3;
             p3 = d3 * 2;
             p4 = d4 * 7;
             p5 = d5 * 6;
             p6 = d6 * 5;
             p7 = d7 * 4;
             p8 = d8 * 3;
             p9 = d9 * 2;            
          }
                    
          suma = p1 + p2 + p3 + p4 + p5 + p6 + p7 + p8 + p9;                
          residuo = suma % modulo;                                         
    
          /* Si residuo=0, dig.ver.=0, caso contrario 10 - residuo*/
         var  digitoVerificador = residuo==0 ? 0: modulo - residuo;                
    
          /* ahora comparamos el elemento de la posicion 10 con el dig. ver.*/                         
          if (pub==true){           
             if (digitoVerificador != d9){                          
                console.log('El ruc de la empresa del sector público es incorrecto.');            
                resultVal1 = false;
             }                  
             /* El ruc de las empresas del sector publico terminan con 0001*/         
             if ( numero.substr(9,4) != '0001' ){                    
                console.log('El ruc de la empresa del sector público debe terminar con 0001');
                resultVal1 = false;
             }
          }         
          else if(pri == true){         
             if (digitoVerificador != d10){                          
                console.log('El ruc de la empresa del sector privado es incorrecto.');
                resultVal1 = false;
             }         
             if ( numero.substr(10,3) != '001' ){                    
                console.log('El ruc de la empresa del sector privado debe terminar con 001');
                resultVal1 = false;
             }
          }      
    
          else if(nat == true){         
             if (digitoVerificador != d10){                          
                console.log('El número de cédula de la persona natural es incorrecto.');
                resultVal1 = false;
             }         
             if (numero.length >10 && numero.substr(10,3) != '001' ){                    
                console.log('El ruc de la persona natural debe terminar con 001');
                resultVal1 = false;
             }
          }
          if(resultVal1 == true) {
            console.log('TODO OK');
            return true;   
          }      
          
        

        console.log(resultVal1);

        if( resultVal1 == false){
            var ci = data;
            var isNumeric = true;
            var total = 0, 
              individual;	
          
            for (var position = 0 ; position < 10 ; position++) {
              // Obtiene cada posición del número de cédula
              // Se convierte a string en caso de que 'ci' sea un valor numérico
              individual = ci.toString().substring(position, position + 1)
          
              if(isNaN(individual)) {
                console.log(ci, position,individual, isNaN(individual))
                isNumeric=false;				
                break;			
              } else {
                // Si la posición es menor a 9
                if(position < 9) {
                  // Si la posición es par, osea 0, 2, 4, 6, 8.
                  if(position % 2 == 0) {
                    // Si el número individual de la cédula es mayor a 5
                    if(parseInt(individual)*2 > 9) {
                      // Se duplica el valor, se obtiene la parte decimal y se aumenta uno 
                      // y se lo suma al total
                      total += 1 + ((parseInt(individual)*2)%10);
                    } else {
                      // Si el número individual de la cédula es menor que 5 solo se lo duplica
                      // y se lo suma al total
                      total += parseInt(individual)*2;
                    }
                  // Si la posición es impar (1, 3, 5, 7)
                  }else {
                    // Se suma el número individual de la cédula al total
                    total += parseInt(individual);		    		
                  }
                } 
              }
            }
          
            if((total % 10) != 0) {
              total =  (total - (total%10) + 10) - total;		
            } else {
              total = 0 ; 	
            }
          
          
            if(isNumeric) {	
              // El total debe ser igual al último número de la cédula
              console.log(ci, total, individual);
              console.log(ci, typeof ci, ci.length)
              // La cédula debe contener al menos 10 dígitos
              if(ci.toString().length != 10) { 
                console.log("La c\u00E9dula debe ser de: 10 d\u00EDgitos.");
                return false; 
              }
          
              // El número de cédula no debe ser cero
              if (parseInt(ci, 10) == 0) { 
                console.log("La c\u00E9dula ingresada no puede ser cero.");
                return false;
              }
          
              // El total debe ser igual al último número de la cédula
              if(total != parseInt(individual)) { 
                console.log("La c\u00E9dula ingresada no es v\u00E1lida.");
                return false;
              } 
          
              console.log('cédula válida', ci);
              return true;			
            }
          
            // Si no es un número  
            console.log("El dato solo puede contener numeros.");
            return false;
          }
        }



        
      
    });
    Validator.extend("dnicolombia", {
      getMessage: field => "El dni colombiano ingresado no es válido",
      validate: data => {
        return true;
      }
    });
    Validator.extend("dnicostarica", {
      getMessage: field => "El dni colombiano ingresado no es válido",
      validate: data => {
        return true;
      }
    });
    Validator.extend("dniperu", 
      {
        getMessage: field => "El dni peruano ingresado no es válido",
        validate: data => {
          const dni = data.trim();
          if (!dni || dni.length < 8 || dni.length > 9) return false;
          return true;
        }
      }
    //   getMessage: field => "El dni peruano ingresado no es válido",
    //   validate: data => {
    //     const dni = data
    //       .replace("-", "")
    //       .replace(/\./g, "")
    //       .trim()
    //       .toUpperCase();

    //     if (!dni || dni.length < 9) return false;
    //     const multiples = [3, 2, 7, 6, 5, 4, 3, 2];
    //     const dcontrols = {
    //       numbers: [6, 7, 8, 9, 0, 1, 1, 2, 3, 4, 5],
    //       letters: ["K", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J"]
    //     };
    //     const numdni = dni.substring(0, dni.length - 1).split("");
    //     const dcontrol = dni.substring(dni.length - 1);
    //     const dsum = numdni.reduce((acc, digit, index) => {
    //       acc += digit * multiples[index];
    //       return acc;
    //     }, 0);
    //     const key = 11 - (dsum % 11);
    //     const index = key === 11 ? 0 : key;
    //     if (/^\d+$/.test(dni)) {
    //       return dcontrols.numbers[index] === parseInt(dcontrol, 10);
    //     }
    //     console.log(dcontrols.letters[index] === dcontrol);
    //     return dcontrols.letters[index] === dcontrol;
    //   }
    // }
    );
    Validator.extend("dniperu2", {
      getMessage: field => "El dni peruano ingresado no es válido",
      validate: data => {
        const dni = data.trim();
        if (!dni || dni.length < 8 || dni.length > 9) return false;
        return true;
      }
    });
    Validator.extend("dnichile", {
      getMessage: field => "El rut ingresado no es válido",
      validate: rut => {
        if (rut.toString().trim() != "" && rut.toString().indexOf("-") > 0) {
          var caracteres = new Array();
          var serie = new Array(2, 3, 4, 5, 6, 7);
          var dig = rut.toString().substr(rut.toString().length - 1, 1);
          rut = rut.toString().substr(0, rut.toString().length - 2);

          for (var i = 0; i < rut.length; i++) {
            caracteres[i] = parseInt(rut.charAt(rut.length - (i + 1)));
          }

          var sumatoria = 0;
          var k = 0;
          var resto = 0;

          for (var j = 0; j < caracteres.length; j++) {
            if (k == 6) {
              k = 0;
            }
            sumatoria += parseInt(caracteres[j]) * parseInt(serie[k]);
            k++;
          }

          resto = sumatoria % 11;
          let dv = 11 - resto;

          if (dv == 10) {
            dv = "K";
          } else if (dv == 11) {
            dv = 0;
          }

          if (
            dv
              .toString()
              .trim()
              .toUpperCase() ==
            dig
              .toString()
              .trim()
              .toUpperCase()
          )
            return true;
          else return false;
        } else {
          return false;
        }
      }
    });
  }
};
